// extracted by mini-css-extract-plugin
module.exports = {"popover":"Popover_popover__2WjDu","top":"Popover_top__1_GyU","container":"Popover_container__3uW2u","animate":"Popover_animate__1tyCF"};